import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';
// Types
import { Ranking } from 'types/lottery/ranking';

export const rankingState = atom<Ranking[]>({
  key: ATOM_KEYS.RANKING_STATE,
  default: [],
});
